import { combineReducers } from '@reduxjs/toolkit';

import badgesSlice from './slices/badge-slice';
import componentSettingsSlice from './slices/component-settings-slice';
import globalSettingsSlice from './slices/global-settings-slice';
import membersPrivacySlice from './slices/members-privacy-slice';
import profilePageSlice from './slices/profile-page-slice';
import rolesSlice from './slices/roles-slice';
import siteSlice from './slices/site-slice';
import uiSlice from './slices/ui-slice';
import usersSlice from './slices/users-slice';

const rootReducer = combineReducers({
  users: usersSlice.reducer,
  badges: badgesSlice.reducer,
  roles: rolesSlice.reducer,
  site: siteSlice.reducer,
  profilePage: profilePageSlice.reducer,
  globalSettings: globalSettingsSlice.reducer,
  componentSettings: componentSettingsSlice.reducer,
  membersPrivacy: membersPrivacySlice.reducer,
  ui: uiSlice.reducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
